import api from "./axios";
import type { Cabin } from "../types";

export const cabinsApi = {
  list: async (params?: { cabinGroupId?: number; includeArchived?: boolean; termId?: number; year?: number }): Promise<Cabin[]> => {
    const res = await api.get<Cabin[]>("/cabins", { params });
    return res.data;
  },

  get: async (id: number, params?: { year?: number; termId?: number }): Promise<Cabin> => {
    const res = await api.get<Cabin>(`/cabins/${id}`, { params });
    return res.data;
  },

  create: async (data: { name: string; cabinGroupId?: number | null; divisionId?: number | null }): Promise<Cabin> => {
    const res = await api.post<Cabin>("/cabins", data);
    return res.data;
  },

  update: async (id: number, data: { name?: string; cabinGroupId?: number | null; divisionId?: number | null }): Promise<Cabin> => {
    const res = await api.put<Cabin>(`/cabins/${id}`, data);
    return res.data;
  },

  archive: async (id: number): Promise<Cabin> => {
    const res = await api.patch<Cabin>(`/cabins/${id}/archive`);
    return res.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/cabins/${id}`);
  },

  assignCounselor: async (id: number, userId: number, termId?: number): Promise<void> => {
    await api.patch(`/cabins/${id}/assign-counselor`, { userId, termId });
  },

  removeCounselor: async (id: number, userId: number, termId?: number): Promise<void> => {
    await api.patch(`/cabins/${id}/remove-counselor`, { userId, termId });
  },

  /**
   * Set or clear the override-cabin for an existing counselor assignment.
   * Pass `null` to clear the override and revert to the sync-assigned cabin.
   */
  overrideCounselorCabin: async (
    cabinId: number,
    userId: number,
    overrideCabinId: number | null,
    termId?: number,
  ): Promise<void> => {
    await api.patch(`/cabins/${cabinId}/override-counselor-cabin`, {
      userId,
      overrideCabinId,
      termId: termId ?? null,
    });
  },

  assignCamper: async (id: number, camperId: number, year: number): Promise<void> => {
    await api.patch(`/cabins/${id}/assign-camper`, { camperId, year });
  },

  removeCamper: async (id: number, camperId: number, year: number): Promise<void> => {
    await api.patch(`/cabins/${id}/remove-camper`, { camperId, year });
  },
};
